import React from 'react';
import { Wrapper } from './styles';

const ContentWrapper: React.FC = ({ children }) => (
  <Wrapper>{children}</Wrapper>
);

export default ContentWrapper;
